import React from "react";
import "./Container.scss";
import { Routes, Route, useLocation } from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";

import Header from "./components/common/Header.jsx";
import Footer from "./components/common/Footer.jsx";
import Home from "./pages/Home.jsx";
import About from "./pages/About.jsx";
import Development from "./pages/Development.jsx";
import Music from "./pages/Music.jsx";
import Contact from "./pages/Contact.jsx";

function Container() {
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <div>
      {!isHome && <Header />}
      <TransitionGroup className="transition-group">
        <CSSTransition
          key={location.key}
          timeout={{ enter: 500, exit: 500 }}
          classNames="fade"
        >
          <section
            id="app-container"
            className={`route-section ${isHome ? "home-page" : location.pathname.replace("/", "") + "-page"}`}
          >
            <Routes location={location}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/development" element={<Development />} />
              <Route path="/music" element={<Music />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </section>
        </CSSTransition>
      </TransitionGroup>
      {!isHome && <Footer />}
    </div>
  );
}

export default Container;
